import { useApolloClient } from '@apollo/react-hooks';
import { parseCookies, setCookie } from 'nookies';
import { useSwitchOrganisationMutation, useUpdateLastConnectionMutation } from '@schema';
import { useRouter } from 'next/router';
import gql from 'graphql-tag';

import useSuperAdminLogin from 'components/hooks/useSuperAdminLogin';
import useRole from 'components/hooks/useRole';
import useLanguage from 'components/hooks/useLanguage';

const LANG_QUERY = gql`
  query userLang {
    me {
      id
      languagePreference
    }
  }
`;

export default function useSwitchOrganisation() {
  const apolloClient = useApolloClient();
  const router = useRouter();
  const { superAdminJWT } = parseCookies();
  const [updateLastConnection] = useUpdateLastConnectionMutation();
  const [switchOrga, infos] = useSwitchOrganisationMutation();
  const [userRole] = useRole({ skip: !superAdminJWT });
  const superAdminLogin = useSuperAdminLogin();
  const { language, setLanguage } = useLanguage();

  const handleSwitch = async ({ clientId }) => {
    if (superAdminJWT) return superAdminLogin({ roleSlug: userRole.absoluteSlug, clientId });
    const {
      data: { switchOrganisation },
    } = await switchOrga({ variables: { clientId } });
    setCookie(null, 'jwToken', switchOrganisation.jwToken, {
      secure: true,
      path: '/',
    });
    setCookie(null, 'client_id', switchOrganisation.clientId, {
      secure: true,
      path: '/',
    });
    await updateLastConnection();
    const { data: dataLang } = await apolloClient.query({
      query: LANG_QUERY,
      fetchPolicy: 'no-cache',
    });

    if (dataLang?.me?.languagePreference !== language) {
      await setLanguage(dataLang.me.languagePreference);
    }

    return window.location.replace(router.query.redirectTo || '/');
  };

  return [handleSwitch, infos];
}
